"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asset = void 0;
function asset(path) {
    var _a;
    // @ts-ignore
    let root = (_a = window.assetsRoot) !== null && _a !== void 0 ? _a : '';
    if (path.startsWith('/')) {
        path = path.slice(1);
    }
    if (root === null || root === void 0 ? void 0 : root.endsWith('/')) {
        root = root.slice(0, -1);
    }
    return `${root}/${path}`;
}
exports.asset = asset;
